import { Application } from 'merchant-api/types';

// FUNDING only clears when the loan is disbursed, so an app can sit in FUNDING past its date.
// Hide the messaging a week after the date rather than show a stale one.
const SUPPRESS_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

/** The delayed funding date to show, or undefined when the app isn't in FUNDING. */
export function delayedFundingDate(app: Application | null | undefined): string | undefined {
  if (app?.status !== 'FUNDING') return undefined;
  const fundingDate = app.data?.delayedFundingOn;
  if (!fundingDate) return undefined;
  if (Date.now() - new Date(fundingDate).getTime() > SUPPRESS_AFTER_MS) return undefined;
  return fundingDate;
}
